export const de = {
  // main page
  'Total balance': 'Allgemeines Gleichgewicht',
  Stars: 'STERNE',
  Pending: 'ausstehend',
  Available: 'verfügbar',
  Replenish: 'Zum Auffüllen',
  Send: 'Schicken',
  'Bring out': 'Mitnahme',
  'History of transactions': 'Transaktionsverlauf',

  // menu
  Language: 'Sprache',
  'Delete data': 'Daten löschen',
  'Enter promo code': 'Promo-Code eingeben',
  'Ton Wallet': 'Ton Wallet',
  Support: 'Unterstützung',
  Exit: 'Ausgang',

  // languages page
  Ukrainian: 'Ukrainisch',
  English: 'Englisch',
  Russian: 'Russisch',
  German: 'Deutsch',
  Choose: 'Wählen',
}
